import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import HeaderStats from "components/Headers/HeaderStats.js";

import Dashboard from "views/admin/Dashboard.js";
import Settings from "views/admin/Settings.js";
import Users from "views/admin/Users.js";
import Admins from "views/admin/Admins.js";
import Events from "components/Events/Events";
import CreateEvent from "components/Events/CreateEvent";
import EventRegistrationsList from "components/Events/EventRegistrationsList";
import RegistrationInfo from "components/Events/RegistrationInfo";
// import EditEvent from "components/Events/EditEvent";

import ScanQr from "components/FacilityReservation/ScanQr";
import FacilityReservation from "components/FacilityReservation/FacilityReservation";
import CreateFacilityReservation from "components/FacilityReservation/CreateFacilityReservation";

import Facilites from "components/Facilites/Facilites";
import CreateFacilites from "components/Facilites/CreateFacilites";
// import EditFacility from "components/Facilites/EditFacility";

import AssignInventory from "components/Assign Inventory/AssignInventory";
import AssignCreateInventory from "components/Assign Inventory/AssignCreateInventory";
import Inventory from "components/Inventory/Inventory";
import CreateInventory from "components/Inventory/CreateInventory";
import EditFacility from "components/Facilites/EditFacility";
import PreviewForm from "components/Events/PreviewForm";
import EditInventory from "components/Inventory/EditInventory";
import ViewInventory from "components/Inventory/ViewInventory";
import Clubs from "views/admin/Clubs";
import Labs from "views/admin/Labs";
import LabIncharge from "views/admin/LabIncharge";

import PortalImages from "components/PortalImages/PortalImages";
import ManageBlogs from "views/admin/Blog/ManageBlogs";
import AddEditBlog from "views/admin/Blog/AddEditBlog";
import ManageGalleries from "views/admin/Gallery/ManageGalleries";
import CreateGallery from "views/admin/Gallery/CreateGallery";
import ManageGalleryImages from "views/admin/Gallery/ManageGalleryImages";
import ManageMembers from "views/admin/Member/ManageMembers";
import AddEditMember from "views/admin/Member/AddEditMember";
import ManageLinks from "views/admin/Links/ManageLinks";
import ManageProjects from "views/admin/Project/ManageProjects";
import AddProject from "views/admin/Project/AddProject";
import ProjectDetails from "views/admin/Project/ProjectDetails";
import ManageHeadDesk from "views/admin/HeadDesk/ManageHeadDesk";

const getToken = () => localStorage.getItem("token");
const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    const expired = decoded.exp * 1000 < Date.now();
    if (expired) {
      localStorage.clear();
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

const getRole = () => {
  const token = getToken();
  if (!token) return null;
  try {
    return jwtDecode(token).role;
  } catch {
    return null;
  }
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation();
  const auth = isAuthenticated();
  const role = getRole();
  // if (!auth) {
  //   console.log("!auth");
  //   return <Navigate to="/auth/login" state={{ from: location }} replace />;
  // }

  // if (allowedRoles && !allowedRoles.includes(role)) {
  //   console.log("!allowedRoles");

  //   return <Navigate to="/auth/login" replace />;
  // }

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-dark-primary min-h-screen">
        <AdminNavbar />
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24">{children}</div>
      </div>
    </>
  );
};

const AdminRoutes = () => {
  return (
    <Routes>
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute allowedRoles={["admin", "office manager"]}>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute allowedRoles={["admin", "office manager"]}>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admins"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Admins />
          </ProtectedRoute>
        }
      />
      <Route
        path="/events"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Events />
          </ProtectedRoute>
        }
      />
      <Route
        path="/viewEvent"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <CreateEvent />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editEvent"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <CreateEvent />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createEvent"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <CreateEvent />
          </ProtectedRoute>
        }
      />

      <Route
        path="/eventRegistrationsList"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <EventRegistrationsList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/registrationInfo"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <RegistrationInfo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/preview"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <PreviewForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/facilities"
        element={
          <ProtectedRoute allowedRoles={["admin", "office manager"]}>
            <Facilites />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editFacility"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <CreateFacilites />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createFacility"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <CreateFacilites />
          </ProtectedRoute>
        }
      />
      <Route
        path="/create-facilities/:id/:viewFlag"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <CreateFacilites />
          </ProtectedRoute>
        }
      />

      <Route
        path="/edit-facility/:id"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <EditFacility />
          </ProtectedRoute>
        }
      />

      <Route
        path="/scan-qr"
        element={
          <ProtectedRoute allowedRoles={["admin", "office manager"]}>
            <ScanQr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/facility-reservation"
        element={
          <ProtectedRoute allowedRoles={["admin", "office manager"]}>
            <FacilityReservation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createFacilityReservation"
        element={
          <ProtectedRoute allowedRoles={["admin", "office manager"]}>
            <CreateFacilityReservation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/viewFacilityReservation"
        element={
          <ProtectedRoute allowedRoles={["admin", "office manager"]}>
            <CreateFacilityReservation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editFacilityReservation"
        element={
          <ProtectedRoute allowedRoles={["admin", "office manager"]}>
            <CreateFacilityReservation />
          </ProtectedRoute>
        }
      />

      <Route
        path="/assign-inventory"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AssignInventory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/assign-create-inventory"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AssignCreateInventory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Inventory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/labs"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Labs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lab-incharge"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <LabIncharge />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clubs"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Clubs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/portal-images"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <PortalImages />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createInventory"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <CreateInventory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editInventory"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <EditInventory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/viewInventory"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ViewInventory />
          </ProtectedRoute>
        }
      />

      <Route
        path="/event-registrations-list/"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <EventRegistrationsList />
          </ProtectedRoute>
        }
      />

      <Route
        path="/blogs"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ManageBlogs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createBlog"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AddEditBlog />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editBlog/:id"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AddEditBlog />
          </ProtectedRoute>
        }
      />

      <Route
        path="/galleries"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ManageGalleries />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createGallery"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <CreateGallery />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gallery/:id/images"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ManageGalleryImages />
          </ProtectedRoute>
        }
      />

      <Route
        path="/members"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ManageMembers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createMember"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AddEditMember />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editMember/:id"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AddEditMember />
          </ProtectedRoute>
        }
      />

      <Route
        path="/links"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ManageLinks />
          </ProtectedRoute>
        }
      />

      <Route
        path="/projects"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ManageProjects />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createProject"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AddProject />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editProject/:id"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AddProject />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:id"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ProjectDetails />
          </ProtectedRoute>
        }
      />

      <Route
        path="/headdesk"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ManageHeadDesk />
          </ProtectedRoute>
        }
      />

      <Route path="/" element={<Navigate to="/admin/events" />} />
      <Route path="*" element={<Navigate to="/auth/login" />} />
    </Routes>
  );
};

export default AdminRoutes;
